import React from 'react';
import { Grid, TextField } from '@material-ui/core';

const BorrowerName = ({ location, values, errors, touched, handleChange, handleBlur, disabled }) => {
  return (
    <>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          label="Borrower's First Name"
          name={`${location}.w_Borrower_First_Name`}
          variant='outlined'
          size='small'
          fullWidth
          margin='none'
          value={values.w_Borrower_First_Name}
          onChange={ e => { 
            e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.substr(1).toLowerCase();
            handleChange(e)}}
          onBlur={handleBlur}
          helperText={(touched[location] && errors[location]) && errors[location].w_Borrower_First_Name}
          error={Boolean((touched[location] && errors[location]) && errors[location].w_Borrower_First_Name)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          label="Borrower's Last Name"
          name={`${location}.w_Borrower_Last_Name`}
          variant='outlined'
          size='small'
          fullWidth
          margin='none'
          value={values.w_Borrower_Last_Name}
          onChange={ e => { 
            e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.substr(1).toLowerCase();
            handleChange(e)}}
          onBlur={handleBlur}
          helperText={(touched[location] && errors[location]) && errors[location].w_Borrower_Last_Name}
          error={Boolean((touched[location] && errors[location]) && errors[location].w_Borrower_Last_Name)}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}

export { BorrowerName };
